import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axiosConn from 'config/axiosConn2';
import { Container, Table, Spinner, Alert, Button } from 'react-bootstrap';
import { FaDownload } from "react-icons/fa";
import HeaderAdmin from '../../HeaderAdmin';
import Pagination from './Pagination';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { IoMdArrowRoundBack } from "react-icons/io";
import * as XLSX from 'xlsx';
import { toast } from 'react-toastify';

function ViewSchoolsWithNotifications() {
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location.state || {};
  const [schools, setSchools] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const limit = 12;

  const fetchSchoolsWithNotifications = async (page = 1) => {
    if (!state) {
      setError('State not provided.');
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const res = await axiosConn(
        'post',
        `school-notifications/schools?page=${page}&limit=${limit}`,
        { state }
      );
      if (res.data.status === 'success') {
        setSchools((res.data.schools || []).filter(s => s.school_name));
        setCurrentPage(res.data.currentPage || page);
        setTotalPages(res.data.totalPages || 1);
      } else {
        setError('Failed to fetch schools with notifications.');
      }
    } catch (err) {
      console.error('Error fetching schools with notifications:', err);
      setError('Failed to fetch schools with notifications.');
    }
    setLoading(false);
  };

  // Fetch all schools with notifications for Excel download
  const fetchAllSchoolsWithNotifications = async () => {
    try {
      const res = await axiosConn(
        'post',
        'school-notifications/all-schools-by-state',
        { state }
      );
      if (res.data.status === 'success') {
        return (res.data.schools || []).filter(s => s.school_name);
      } else {
        toast.error('Failed to fetch all schools with notifications.');
        return [];
      }
    } catch (err) {
      console.error('Error fetching all schools with notifications:', err);
      toast.error('Failed to fetch all schools with notifications.');
      return [];
    }
  };

  useEffect(() => {
    fetchSchoolsWithNotifications(currentPage);
    // eslint-disable-next-line
  }, [state, currentPage]);

  const handlePageChange = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  // Download as PDF
  const handleDownloadPDF = () => {
    const doc = new jsPDF();
    doc.setFontSize(16);
    doc.text(`Schools with Notifications in ${state}`, 14, 16);
    const tableData = schools.map((school, idx) => [idx + 1, school.school_name]);
    doc.autoTable({
      head: [["#", "School Name", "District", "Block Name", "School Type"]],
      body: schools.map(school => [school.udise_id || school.udiseCode, school.school_name, school.district, school.eduBlockName, school.school_type || 'N/A']),
      startY: 24,
    });
    doc.save(`Schools_with_Notifications_${state}.pdf`);
  };

  // Download as Excel
  const handleDownloadExcel = () => {
    const wsData = [["#", "School Name", "District", "Block Name", "School Type"], ...schools.map((school, idx) => [idx + 1, school.school_name, school.district, school.eduBlockName, school.school_type || 'N/A'])];
    const ws = XLSX.utils.aoa_to_sheet(wsData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Schools with Notifications");
    XLSX.writeFile(wb, `Schools_with_Notifications_${state}.xlsx`);
  };

  // Download all schools as Excel
  const handleDownloadAllSchoolsExcel = async () => {
    setLoading(true);
    try {
      const allSchools = await fetchAllSchoolsWithNotifications();
      if (allSchools.length > 0) {
        const wsData = [
          ["#", "School Name", "District", "Block Name", "School Type", "UDISE ID"], 
          ...allSchools.map((school, idx) => [
            idx + 1, 
            school.school_name, 
            school.district, 
            school.eduBlockName,
            school.school_type || 'N/A',
            school.udise_id || school.udiseCode || ''
          ])
        ];
        const ws = XLSX.utils.aoa_to_sheet(wsData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "All Schools with Notifications");
        XLSX.writeFile(wb, `All_Schools_with_Notifications_${state}.xlsx`);
        toast.success(`Downloaded ${allSchools.length} schools with notifications`);
      } else {
        toast.warning('No schools found with notifications');
      }
    } catch (error) {
      console.error('Error downloading all schools:', error);
      toast.error('Failed to download all schools');
    }
    setLoading(false);
  };

  return (
    <>
      <HeaderAdmin />
      <section className="scholdashbrdSec superAdminDashboardSec">
        <Container fluid>
          <div className="dashbrdTopSrchDiv lavel mt-3 mb-1" style={{position:"relative", zIndex:999}}>
            <h1 style={{ color: 'orange' }}>EK PED MAA KE NAAM 2.0</h1>
            <h2>State/District <span className="hdngBrkr"> Level </span> SNAPSHOT</h2>
            {/* <h3 style={{letterSpacing: "0.1em"}}>Welcome State Admin- {localStorage.getItem('filterDataState')}</h3> */}
            <h3>Schools with Notifications in {state}</h3>
            
            <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
              {/* Back on the left; download actions grouped on the right. */}
              <Button onClick={(e)=>{
                e.preventDefault();
                window.history.back();
              }}>
                <IoMdArrowRoundBack size={20} color="#dddddd" /> Back
              </Button>
              <div className="d-flex flex-wrap gap-2">
                <Button onClick={handleDownloadPDF} disabled={schools.length === 0}>
                  <FaDownload size={20} color="#dddddd" /> Download PDF
                </Button>
                <Button onClick={handleDownloadExcel} variant="success" disabled={schools.length === 0}>
                  <FaDownload size={20} color="#dddddd" /> Download Excel
                </Button>
                <Button onClick={handleDownloadAllSchoolsExcel} variant="warning" disabled={loading}>
                  <FaDownload size={20} color="#dddddd" /> Download All Schools Excel
                </Button>
              </div>
            </div>
          </div>

          {loading && (
            <div className="text-center mt-4">
              <Spinner animation="border" variant="primary" />
              <p className="mt-2">Loading schools with notifications...</p>
            </div>
          )}
          
          {error && <Alert variant="danger">{error}</Alert>}
          
          {!loading && !error && (
            <>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>School Name</th>
                    <th>District</th>
                    <th>Block Name</th>
                    <th>School Type</th>
                    <th>Notifications Count</th>
                  </tr>
                </thead>
                <tbody>
                  {schools.length === 0 ? (
                    <tr>
                      <td colSpan="6" className="text-center">No schools with notifications found.</td>
                    </tr>
                  ) : (
                    schools.map((school, idx) => (
                      <tr key={school.school_name || idx}>
                        <td>{(currentPage - 1) * limit + idx + 1}</td>
                        <td>{school.school_name}</td>
                        <td>{school.district}</td>
                        <td>{school.eduBlockName}</td>
                        <td>{school.school_type || 'N/A'}</td>
                        <td>{school.notificationCount || 1}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
              
              {totalPages > 1 && (
                <div className="paginationDiv d-flex justify-content-center">
                  <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                  />
                </div>
              )}
            </>
          )}
        </Container>
      </section>
    </>
  );
}

export default ViewSchoolsWithNotifications; 